<template>
  <v-select
    v-if="businessRulesGetBoolean('Inventory Classes')"
    ref="inventoryClassSelectElement"
    v-model="inventoryClassId"
    :items="inventoryClasses"
    item-text="name"
    item-value="id"
    :return-object="returnObject"
    :disabled="disabled"
    :readonly="readonly"
    :rules="[v => !isRequired || (Array.isArray(v) ? (v.length > 0 || 'Class is required') : (!!v || 'Class is required'))]"
    :hide-details="hideDetails"
    :outlined="outlined"
    :dense="dense"
    :loading="loading"
    :multiple="multiple"
    @change="onChange"
  >
    <template #label>
      <span v-if="isLabel">Class<RedAsterisk v-if="isRequired" /></span>
    </template>
    <template #item="{ item }">
      <v-chip
        class="mt-1 mb-1"
        small
        text-color="white"
        style="cursor: pointer; text-transform: uppercase"
        :color="item ? item.color : 'white'"
      >
        {{ item ? item.name : '' }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line vue/no-template-shadow -->
    <template #selection="{ item }">
      <v-chip
        class="mt-1 mb-1"
        small
        text-color="white"
        style="cursor: pointer; text-transform: uppercase"
        :color="item ? item.color : 'white'"
      >
        {{ item ? item.name : '' }}
      </v-chip>
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    value: {
      type: [Array, Number],
      default: null,
    },
    isAddAll: {
      type: Boolean,
      default: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    is4500: {
      type: Boolean,
      default: true,
    },
    is4800: {
      type: Boolean,
      default: true,
    },
    isInst: {
      type: Boolean,
      default: true,
    },
    isRailings: {
      type: Boolean,
      default: true,
    },
    isGlass: {
      type: Boolean,
      default: true,
    },
    isCommercial: {
      type: Boolean,
      default: true,
    },
    isVwdGlass: {
      type: Boolean,
      default: true,
    },
    isPanels: {
      type: Boolean,
      default: true,
    },
    isSid: {
      type: Boolean,
      default: true,
    },
    isRailPart: {
      type: Boolean,
      default: true,
    },
    isParts: {
      type: Boolean,
      default: true,
    },
    isPaint: {
      type: Boolean,
      default: true,
    },
    isEquipment: {
      type: Boolean,
      default: true,
    },
    isPatioDoor: {
      type: Boolean,
      default: true,
    },
    isEuroDoor: {
      type: Boolean,
      default: true,
    },
    isMedicalAid: {
      type: Boolean,
      default: true,
    },
    isFacades: {
      type: Boolean,
      default: true,
    },
    is6000: {
      type: Boolean,
      default: true,
    },
    isService: {
      type: Boolean,
      default: true,
    },
    isOthers: {
      type: Boolean,
      default: true,
    },
    isMaintenance: {
      type: Boolean,
      default: true,
    },
    isUpc: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    isLabel: {
      type: Boolean,
      default: true,
    },
    isState: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    autoSelectFirst: {
      type: Boolean,
      default: true,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    inventoryClasses: [],
    inventoryClassId: null,
    classAllId: 0,
    class4500Id: 1,
    class4800Id: 2,
    classRailingsId: 3,
    classInstId: 4,
    classGlassId: 5,
    classCommercialId: 6,
    VWDGlassId: 7,
    panelsId: 8,
    sidId: 9,
    railPartId: 10,
    partsId: 11,
    paintId: 12,
    equipmentId: 13,
    patioDoorId: 14,
    euroDoorId: 15,
    medicalAidId: 16,
    facadesId: 17,
    class6000Id: 18,
    serviceId: 19,
    othersId: 20,
    maintenanceId: 21,
    loading: false,
  }),
  computed: {
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    ...mapState({
      user: 'user',
    }),
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (v !== null && this.isState) {
          this.$store.commit('storeInventoryClass', v);
        }
        this.inventoryClassId = v;
      },
    },
    inventoryClassId() {
      this.$emit('input', this.inventoryClassId);
    },
    is4500() {
      this.getInvClasses();
    },
    is4800() {
      this.getInvClasses();
    },
    isInst() {
      this.getInvClasses();
    },
    isRailings() {
      this.getInvClasses();
    },
    isGlass() {
      this.getInvClasses();
    },
    isCommercial() {
      this.getInvClasses();
    },
    isVwdGlass() {
      this.getInvClasses();
    },
    isPanels() {
      this.getInvClasses();
    },
    isSid() {
      this.getInvClasses();
    },
    isRailPart() {
      this.getInvClasses();
    },
    isParts() {
      this.getInvClasses();
    },
    isPaint() {
      this.getInvClasses();
    },
    isEquipment() {
      this.getInvClasses();
    },
    isPatioDoor() {
      this.getInvClasses();
    },
    isEuroDoor() {
      this.getInvClasses();
    },
    isMedicalAid() {
      this.getInvClasses();
    },
    isFacades() {
      this.getInvClasses();
    },
    is6000() {
      this.getInvClasses();
    },
    isService() {
      this.getInvClasses();
    },
    isOthers() {
      this.getInvClasses();
    },
    isMaintenance() {
      this.getInvClasses();
    },
  },
  created() {
    this.getInvClasses();
  },
  methods: {
    async getInvClasses() {
      try {
        this.loading = true;

        this.inventoryClasses = [];

        const inventoryClasses = this.$store.state.invClasses;

        if (!inventoryClasses) {
          this.loading = false;
          return;
        }

        let filteredClasses = [];

        if (this.isUpc) {
          filteredClasses = inventoryClasses.filter((x) => (x.parameter && x.parameter.is_upc === 1));
        } else {
          filteredClasses = inventoryClasses.filter(x => {
            const id = x.id;

            if (id === this.classAllId && !this.isAddAll) return false;
            if (id === this.class4500Id && !this.is4500) return false;
            if (id === this.class4800Id && !this.is4800) return false;
            if (id === this.classInstId && !this.isInst) return false;
            if (id === this.classRailingsId && !this.isRailings) return false;
            if (id === this.classGlassId && !this.isGlass) return false;
            if (id === this.classCommercialId && !this.isCommercial) return false;
            if (id === this.VWDGlassId && !this.isVwdGlass) return false;
            if (id === this.panelsId && !this.isPanels) return false;
            if (id === this.sidId && !this.isSid) return false;
            if (id === this.railPartId && !this.isRailPart) return false;
            if (id === this.partsId && !this.isParts) return false;
            if (id === this.paintId && !this.isPaint) return false;
            if (id === this.equipmentId && !this.isEquipment) return false;
            if (id === this.patioDoorId && !this.isPatioDoor) return false;
            if (id === this.euroDoorId && !this.isEuroDoor) return false;
            if (id === this.medicalAidId && !this.isMedicalAid) return false;
            if (id === this.facadesId && !this.isFacades) return false;
            if (id === this.class6000Id && !this.is6000) return false;
            if (id === this.serviceId && !this.isService) return false;
            if (id === this.othersId && !this.isOthers) return false;
            if (id === this.maintenanceId && !this.isMaintenance) return false;

            return true;
          });
        }

        this.inventoryClasses.push(...filteredClasses);

        if (this.isState && filteredClasses.some((el) => el.id === this.$store.state.inventoryClassId)) {
          this.inventoryClassId = this.$store.state.inventoryClassId;
        } else if (this.inventoryClassId === null && filteredClasses.length > 0 && this.autoSelectFirst) {
          this.inventoryClassId = filteredClasses[0].id;
        }

        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },

    onChange(value) {
      if (this.multiple && Array.isArray(value)) {
        const hasAll = value.includes(this.classAllId);
        const previousHadAll = Array.isArray(this.value) && this.value.includes(this.classAllId);

        if (hasAll && !previousHadAll) {
          this.inventoryClassId = [this.classAllId];
          this.$emit('on-change', this.inventoryClassId);
          return;
        }

        if (hasAll && value.length > 1) {
          this.inventoryClassId = value.filter(id => id !== this.classAllId);
          this.$emit('on-change', this.inventoryClassId);
          return;
        }
      }

      this.$emit('on-change', value);
    },

    validate() {
      return this.$refs.inventoryClassSelectElement.validate();
    },
  },
};
</script>
